export default "__VITE_ASSET__Du1n9mxk__"